import React from "react";
import { IntlProvider } from "react-intl";
import itMessages from "./i18n/it_IT.json";
import enMessages from "./i18n/en_US.json"; // Assume you have English translations

var messagesMap = {
  "it": itMessages,
  // Fallback to Italian if no region is provided
  "en": enMessages // Fallback to English if no region is provided
};
export function getProductSuffix() {
  return ".html";
}
export function getCategorySuffix() {
  return ".html";
}
var LocaleProvider = _ref => {
  var {
    locale,
    children
  } = _ref;
  // Detect the user's locale or default to 'it-IT'
  var detectedLocale = locale || navigator.language || "it-IT";

  // Extract the language code (e.g., 'en' from 'en-GB')
  var languageCode = detectedLocale.split('-')[0];

  // Try to find messages for the full locale
  var messages = messagesMap[detectedLocale];

  // If not found, try to find messages for the language code
  if (!messages) {
    messages = messagesMap[languageCode];
  }

  // If still not found, default to Italian messages
  if (!messages) {
    messages = itMessages;
  }
  var onIntlError = error => {
    if (error.code === "MISSING_TRANSLATION") {
      console.warn("Missing translation", error.message);
      return;
    }
    throw error;
  };
  return /*#__PURE__*/React.createElement(IntlProvider, {
    key: detectedLocale,
    locale: detectedLocale,
    defaultLocale: "it-IT",
    messages: messages,
    onError: onIntlError
  }, children);
};
export default LocaleProvider;